export default __webpack_public_path__ + "static/media/rocket_anim_39.a75f1aef.png";